import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';
import { StorebuilderService } from 'src/app/core/services/storebuilder.service';
import { StoredetailsService } from 'src/app/core/services/storedetails.service';

let moment = require('moment')

@Component({
  selector: 'app-store-layout',
  templateUrl: './store-layout.component.html',
  styleUrls: ['./store-layout.component.scss']
})
export class StoreLayoutComponent implements OnInit {

  teamStoreId: any;
  layoutData: any;
  teamStoreName = 'store'
  selectedComponent: any = 0;
  loading = false
  isStoreClosed = false
  versionStore: boolean;
  teamStoreData: any;
  dataLoaded: boolean = false;
  constructor(
    private storeDetailsService: StoredetailsService,
    private route: ActivatedRoute, private storeBuilderService: StorebuilderService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.teamStoreId = this.route.snapshot.params.storeId;
    if (this.teamStoreId == undefined)
      this.teamStoreId = parseInt(localStorage.getItem("teamStoreId"));
    const storedVersionStore = localStorage.getItem("versionStore");
    this.versionStore = storedVersionStore === 'true'; // Boolean conversion
    // this.getLayoutSettings();
    // this.getTeamStore(this.teamStoreId);
    Promise.all([this.getTeamStore(this.teamStoreId), this.getLayoutSettings()])
      .then(() => {
        // this.setLayoutData(null);  // Optional if layoutData is already handled inside `getLayoutSettings`
        this.dataLoaded = true;   // Only render after both are ready
      });

  }

  // getLayoutSettings() {
  //   this.loading = true
  //   if (this.versionStore) {
  //     this.storeDetailsService.getLayoutSettingsForVersionStore(this.teamStoreId).subscribe((response) => {
  //       this.isStoreClosed = moment() > moment(response.data.closeDate, 'MM/DD/YYYY HH:mm:ss')
  //       this.selectedComponent = response.data.layout.componentId;
  //       this.layoutData = JSON.parse(response.data.style);
  //       this.layoutData["closeDate"] = response.data.closeDate
  //       this.layoutData["disclaimer"] = response.data.disclaimer
  //       this.teamStoreName = response.data.teamStoreName ? response.data.teamStoreName : "store"
  //       this.loading = false
  //     }, (err) => {
  //       this.loading = false
  //       this.layoutData = null
  //     });
  //   } else {
  //     this.storeDetailsService.getLayoutSettings(this.teamStoreId).subscribe((response) => {
  //       this.isStoreClosed = moment() > moment(response.data.closeDate, 'MM/DD/YYYY HH:mm:ss')
  //       this.selectedComponent = response.data.layout.componentId;
  //       this.layoutData = JSON.parse(response.data.style);
  //       this.layoutData["closeDate"] = response.data.closeDate
  //       this.layoutData["disclaimer"] = response.data.disclaimer
  //       this.teamStoreName = response.data.teamStoreName ? response.data.teamStoreName : "store"
  //       this.loading = false
  //     }, (err) => {
  //       this.loading = false
  //       this.layoutData = null
  //     });
  //   }
  //   // this.storeDetailsService.getLayoutSettings(this.teamStoreId).subscribe((response) => {
  //   //   this.isStoreClosed = moment() > moment(response.data.closeDate, 'MM/DD/YYYY HH:mm:ss')
  //   //   this.selectedComponent = response.data.layout.componentId;
  //   //   this.layoutData = JSON.parse(response.data.style);
  //   //   this.layoutData["closeDate"] = response.data.closeDate
  //   //   this.layoutData["disclaimer"] = response.data.disclaimer
  //   //   this.teamStoreName = response.data.teamStoreName ? response.data.teamStoreName : "store"
  //   //   this.loading = false
  //   // },(err)=>{
  //   //   this.loading = false
  //   //   this.layoutData = null
  //   // });
  // }

  getLayoutSettings(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.loading = true
      if (this.versionStore) {
        this.storeDetailsService.getLayoutSettingsForVersionStore(this.teamStoreId).subscribe((response) => {
          this.isStoreClosed = moment() > moment(response.data.closeDate, 'MM/DD/YYYY HH:mm:ss')
          this.selectedComponent = response.data.layout.componentId;
          this.layoutData = JSON.parse(response.data.style);
          this.layoutData["closeDate"] = response.data.closeDate
          this.layoutData["disclaimer"] = response.data.disclaimer
          this.teamStoreName = response.data.teamStoreName ? response.data.teamStoreName : "store"
          resolve();
          this.loading = false
        }, (err) => {
          this.loading = false
          this.layoutData = null
        });
      } else {
        this.storeDetailsService.getLayoutSettings(this.teamStoreId).subscribe((response) => {
          this.isStoreClosed = moment() > moment(response.data.closeDate, 'MM/DD/YYYY HH:mm:ss')
          this.selectedComponent = response.data.layout.componentId;
          this.layoutData = JSON.parse(response.data.style);
          this.layoutData["closeDate"] = response.data.closeDate
          this.layoutData["disclaimer"] = response.data.disclaimer
          this.teamStoreName = response.data.teamStoreName ? response.data.teamStoreName : "store"
          resolve();
          this.loading = false
        }, (err) => {
          resolve();
          this.loading = false
          this.layoutData = null
        });
      }
      // this.storeDetailsService.getLayoutSettings(this.teamStoreId).subscribe((response) => {
      //   this.isStoreClosed = moment() > moment(response.data.closeDate, 'MM/DD/YYYY HH:mm:ss')
      //   this.selectedComponent = response.data.layout.componentId;
      //   this.layoutData = JSON.parse(response.data.style);
      //   this.layoutData["closeDate"] = response.data.closeDate
      //   this.layoutData["disclaimer"] = response.data.disclaimer
      //   this.teamStoreName = response.data.teamStoreName ? response.data.teamStoreName : "store"
      //   this.loading = false
      // },(err)=>{
      //   this.loading = false
      //   this.layoutData = null
      // });
    });


  }





  getTeamStore(teamStoreId): Promise<void> {
    return new Promise((resolve, reject) => {
      this.storeBuilderService.getTeamStore(teamStoreId, this.versionStore).subscribe(
        (response) => {
          this.teamStoreData = response.data;
          console.log(this.teamStoreData, "this.teamStoreData");

          // Set values if not already set
          // if (!this.layoutData.closeDate) {
          //   this.layoutData['closeDate'] = this.teamStoreData.closeDate;
          // }

          // if (!this.layoutData.header.logoUrl) {
          //   this.layoutData.header.logoUrl = this.teamStoreData.logo;
          // }

          resolve();
        },
        (error) => {
          this.commonService.openErrorSnackBar(error.message, "");
          resolve();  // Or reject if you want to handle it differently
        }
      );
    });
  }

}
